<template>
  <div class="slider-component">
    <div class="slider-wrapper">
      <div ref="slider"></div>
    </div>
    <div class="zoll text-center">
      Empfohlene Fernsehergröße: <strong>{{ this.newMinSize }}</strong> - <strong>{{ this.newMaxSize }}</strong> Zoll
    </div>
  </div>
</template>

<script>
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export default {
  props: {
    minSize: {
      type: Number,
      default: 52,
    },
    maxSize: {
      type: Number,
      default: 68,
    }
  },
  data() {
    return {
      lowerValue: 2.5,
      newMinSize: this.minSize,
      newMaxSize: this.maxSize
    };
  },
  mounted() {
    this.initSlider();
  },
  methods: {
    initSlider() {
      const sliderElement = this.$refs.slider;

      noUiSlider.create(sliderElement, {
        start: this.lowerValue,
        connect: true,
        range: {
          min: 0.0,
          max: 6.0
        },
        step: 0.1,
        tooltips: true,
        format: {
          to: function (value) {
              return value.toFixed(1) + ' Meter';
            },
          from: function (value) {
              return parseFloat(value.replace(' Meter', ''));
          }
        }
      });
      sliderElement.noUiSlider.on('update', (values) => {
        const lowerValue = Number(values[0].replace(' Meter', ''));
        this.lowerValue = lowerValue;
        this.newMinSize = this.calculateTVSizeLower(this.lowerValue);
        this.newMaxSize = this.calculateTVSizeUpper(this.lowerValue);
        this.$emit('update-slider', this.lowerValue);
        this.$emit('update-slider', {minSize: this.newMinSize, maxSize: this.newMaxSize });

      });
    },

    calculateTVSizeLower(distanceInMeters) {
      const distanceInInches = distanceInMeters * 39.37;
      const minSize = 2 * (distanceInInches * Math.tan((30 / 2) * (Math.PI / 180)));
      const adjustedMinSize = minSize * 0.9;
      return parseFloat(adjustedMinSize.toFixed(1));
    },
    calculateTVSizeUpper(distanceInMeters) {
      const distanceInInches = distanceInMeters * 39.37;
      const maxSize = 2 * (distanceInInches * Math.tan(Math.PI / 9)); 
      const adjustedMaxSize = maxSize * 0.85; 

      return parseFloat(adjustedMaxSize.toFixed(1)); 
    }
  }
};
</script>

<style>
.slider-component {
  width: 70%;
  margin: 0 auto;
  margin-bottom: 5%;
  margin-top: 5%;
}

.slider-wrapper {
  width: 100%;
}

.noUi-handle {
  background-color: #E7EFFB;
}

.noUi-connect {
  background-color: #6CB5F5;
}

.zoll {
  margin-top: 40px;
}
</style>
